// import layoutHelpers from '@/layout/helpers.js'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import * as numeral from 'numeral'
import { AUTH_LOGOUT } from './store/actions/auth'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

export default {
  computed: {
    loggedUserName () {
      return this.$store.state.user.profile.name
    }
  },
  methods: {
    syncLogout () {
      // console.log('syncLogout () status: ' + this.$store.state.auth.status)
      if (event.key === 'logout' && this.$store.state.auth.status !== 'logout') {
        this.$store.dispatch(AUTH_LOGOUT).then(() => { this.$router.push('/login') })
      }
    },
    hasAnyRole (roles) {
      if (roles) {
        if (this.$store.state.user.status === 'authenticated') {
          for (var i = 0; i < roles.length; i++) {
            if (this.$store.state.user.profile.authorityCollection.some(item => item.authorityId === roles[i])) {
              return true
            }
          }
        } else {
          return false
        }
      }
      return false
    },
    /*
    roundDecimals (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    */
    hideModal (id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    showModal (id) {
      this.$root.$emit('bv::show::modal', id)
    },
    toastError (message, duration = 5000) {
      message = '<i class="ion ion-md-close mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-danger text-white font-weight-bold'
      this.toast(message, duration, className)
    },
    toastWarn (message, duration = 5000) {
      message = '<i class="ion ion-md-warning mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-warning text-dark'
      this.toast(message, duration, className)
    },
    toastSuccess (message, duration = 5000) {
      message = '<i class="ion ion-md-checkmark mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-success text-white font-weight-bold'
      this.toast(message, duration, className)
    },
    toast (message, duration, className) {
      try {
        Vue.toasted.clear()
        Vue.toasted.show(message, {
          theme: 'bubble',
          position: 'top-right',
          className: className,
          duration: duration,
          singleton: true,
          keepOnHover: true
        })
      } catch (e) {
        console.error('Trying to display message: ' + message)
        console.error(e)
      }
    },
    formatDate (value, format = 'YYYY-MM-DD  H:mm') {
      return moment(value).format(format)
    },
    formatCurrencyNumber (value) {
      return numeral(value).format('0,0.00')
    },
    formatCurrency (value, prepend = '$') {
      return numeral(value).format(prepend + '0,0.00')
    },
    formatUpperCase (value) {
      return value.toUpperCase()
    },
    /**
     * Comparable form of an address, used to know whether the user actually changed it.
     *
     * @param {Object} location address as held by a customer form
     * @returns {String} normalized representation, empty when there is no address
     */
    addressSnapshot (location) {
      if (!location) {
        return ''
      }
      return ['street', 'number', 'districtName', 'postalCode', 'cityName', 'stateName',
        'countryCode', 'placeId', 'geoLat', 'geoLng', 'references']
        .map(field => (location[field] === null || location[field] === undefined ? '' : String(location[field]).trim()))
        .join('|')
    },
    /**
     * Every shipping order keeps its own copy of the address it was created with, so a
     * customer moving does not silently redirect what is already on its way. Asks the
     * user whether the orders still pending dispatch should follow the new address.
     *
     * @param {String} customerUuid customer being saved
     * @returns {Promise<Boolean>} true when the pending orders must be updated
     */
    confirmShippingOrderAddressUpdate (customerUuid) {
      if (!customerUuid) {
        return Promise.resolve(false)
      }
      return axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + 'customer/' + customerUuid + '/openShippingOrders', method: 'GET' })
        .then(response => {
          const orders = response.data || []
          if (orders.length === 0) {
            return false
          }
          const codes = orders.map(order => order.code).join(', ')
          const message = 'El cliente tiene ' + orders.length + (orders.length === 1 ? ' orden de envío pendiente' : ' órdenes de envío pendientes') +
            ' de entrega (' + codes + ') con la dirección anterior. ¿Deseas actualizarlas con la nueva dirección?'
          return this.$bvModal.msgBoxConfirm(message, {
            title: 'Órdenes de envío pendientes',
            okTitle: 'Sí, actualizar',
            cancelTitle: 'No, conservar la anterior',
            okVariant: 'primary',
            cancelVariant: 'default',
            centered: true,
            noEnforceFocus: true
          }).then(answer => answer === true)
        })
        // the address change must not be blocked by a failure to read the pending orders
        .catch(() => false)
    },
    /**
     * Phone numbers are stored as bare digits and displayed with the same
     * (000) 000-0000 mask used when capturing them. Values that are not 10 digits
     * are shown as stored, and an empty phone renders as a dash.
     */
    formatPhone (phoneNumber) {
      if (!phoneNumber) {
        return '-'
      }
      const digits = String(phoneNumber).replace(/\D/g, '')
      if (digits.length !== 10) {
        return String(phoneNumber)
      }
      return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6)
    },
    convertNumber (value) {
      return Number(numeral(value).format('0.00'))
    },
    round (n, digits = 0) {
      var negative = false
      if (n < 0) {
        negative = true
        n = n * -1
      }
      var multiplicator = Math.pow(10, digits)
      n = parseFloat((n * multiplicator).toFixed(11))
      n = (Math.round(n) / multiplicator).toFixed(digits)
      if (negative) {
        n = (n * -1).toFixed(digits)
      }
      return Number(n)
    },
    pad (num, size) {
      let s = num + ''
      while (s.length < size) s = '0' + s
      return s
    },
    generateRandomNumber (length) {
      return Math.floor(Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1))
    },
    sortCompareAdvanced (a, b, key) {
      var flatten = require('flat')
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // if (flatten(a).hasOwnProperty(key) && flatten(b).hasOwnProperty(key)) {
        if (Object.prototype.hasOwnProperty.call(flatten(a), key) && Object.prototype.hasOwnProperty.call(flatten(b), key)) {
          // Stringify the field data and use String.localeCompare
          return (flatten(a)[key]).toString().localeCompare((flatten(b)[key]).toString(), undefined, {
            numeric: true
          })
        } else {
          // if (flatten(a).hasOwnProperty(key) && !flatten(b).hasOwnProperty(key)) {
          if (Object.prototype.hasOwnProperty.call(flatten(a), key) && !Object.prototype.hasOwnProperty.call(flatten(b), key)) {
            return -1
          }
          return 1
        }
      }
    },
    objectDeepKeys (obj) {
      var keys = []
      for (var key in obj) {
        keys.push(key)
        if (typeof obj[key] === 'object') {
          var subkeys = this.objectDeepKeys(obj[key])
          keys = keys.concat(subkeys.map(function (subkey) {
            return key + '.' + subkey
          }))
        }
      }
      return keys
    }
  }
}
